export default "__VITE_ASSET__D5fDy2eo__"